import React from "react"
import type { Locale } from "popopo-msg/routes"
import type { MobileAppBannerProps } from "./SimplePage"
import { getMessages } from "../messages"

export const MobileAppBanner: React.FC<MobileAppBannerProps & { locale: Locale }> = ({
  locale,
  appIconUrl,
  onOpen,
}) => {
  const msg = getMessages(locale)

  return (
    <div className="simple-page-mobile-banner">
      <div className="simple-page-mobile-banner__content">
        <img
          src={appIconUrl}
          alt="POPOPO"
          className="simple-page-mobile-banner__icon"
        />
        <div className="simple-page-mobile-banner__text">
          <span className="simple-page-mobile-banner__name">{msg.mobileAppBanner.appName}</span>
          <span className="simple-page-mobile-banner__subtitle">{msg.mobileAppBanner.subtitle}</span>
        </div>
      </div>
      <button
        onClick={onOpen}
        className="simple-page-mobile-banner__button"
      >
        {msg.mobileAppBanner.openButton}
      </button>
    </div>
  )
}
